import { REDUX_STORE } from '@funnels/constants';
import { FetchLeadAction, FetchLeadFailAction, FetchLeadSuccessAction, StoreLead } from '@funnels/types';

export function fetchLead(leadID: string): FetchLeadAction {
  return { type: REDUX_STORE.LEAD.ACTION_TYPES.FETCH_LEAD, leadID };
}

export function fetchLeadFail(error: string): FetchLeadFailAction {
  return { type: REDUX_STORE.LEAD.ACTION_TYPES.FETCH_LEAD_FAIL, error };
}

export function fetchLeadSuccess(lead: StoreLead): FetchLeadSuccessAction {
  return { type: REDUX_STORE.LEAD.ACTION_TYPES.FETCH_LEAD_SUCCESS, lead };
}
